import React from 'react';
import './msg_preview.css'
import Vars from "../../cmpts/system_vars";
import MsgUtil from "../../ext/msg/msg_util";
import TaskposterUtil from "../../ext/taskpost/taskposter_util";

class MsgPreview extends React.Component {

    constructor(props) {
        super(props);
        var date = new Date();
        var msg = this.parseMsg(props.msg);
        this.detail = this.detail.bind(this);
        this.hasDetail = this.hasDetail.bind(this);
        this.state = {
            time: (date.getMonth() + 1) + '月' + (date.getDate()) + '日',
            paras: msg.paras,
            url: msg.url,
            title: msg.title,
            miniprogram: msg.miniprogram
        };
    }

    parseMsg(msg) {
        var paras = [];
        var url = null, title = null, miniprogram = null;
        if (msg && msg != null) {
            msg = JSON.parse(JSON.stringify(msg));
            if (typeof msg.data == "string") {
                msg.data = JSON.parse(msg.data)
            }
            // console.log(msg)
            url = msg.url;
            title = msg.title;
            miniprogram = msg.miniprogram;
            var tmp = msg.content.split('TEMP_MXD_ENTER');
            for (var i = 0; i < tmp.length; i++) {
                if (tmp[i].length > 0) {
                    var p = tmp[i];
                    var items = [];
                    while (true) {
                        var lindex = p.indexOf("{{");
                        if (lindex < 0) {
                            lindex = p.indexOf("{")
                        }
                        if (lindex < 0) {
                            if (p.length > 0) {
                                items.push({
                                    value: [p],
                                    type: 'text'
                                });
                            }
                            break;
                        } else {
                            if (lindex > 0) {
                                var pre = p.substring(0, lindex);
                                items.push({
                                    value: [pre],
                                    type: 'text'
                                });
                                p = p.substring(lindex);
                            }
                            var rindex = p.indexOf("}}");
                            var offset = 2;
                            if (rindex < 0) {
                                rindex = p.indexOf("}");
                                offset = 1;
                            }
                            var keytmp = p.substring(0, rindex);
                            var key = MsgUtil.getTemplateKey(keytmp);
                            var itemData = msg.data[key];
                            var value = this.props.preview ? ['{{' + key + '.DATA}}'] : [''];
                            var color = {
                                color: '#000000'
                            };
                            if (itemData) {
                                if (itemData.value && itemData.value.length > 0) {
                                    itemData.value = TaskposterUtil.transformDATA(itemData.value);
                                    value = itemData.value.split('\n');
                                }
                                if (itemData.color && itemData.color.length > 0) {
                                    color = {
                                        color: itemData.color
                                    }
                                }
                            }
                            items.push({
                                value: value,
                                color: color,
                                type: 'var'
                            });
                            p = p.substring(rindex + offset);
                        }
                    }
                    paras.push(items);
                } else {
                    paras.push([{
                        value: [tmp[i]],
                        type: 'text'
                    }]);
                }
            }
        }
        return {
            paras: paras,
            url: url,
            title: title,
            miniprogram: miniprogram
        };
    }

    transformDATA(value) {
        var re = new RegExp("#NICKNAME#", "g");
        value = value.replace(re, Vars.NICKNAME_ITEM());
        re = new RegExp("#COMPLETED_TASK_NUM#", "g");
        value = value.replace(re, Vars.COMPLETED_TASK_NUM_ITEM());
        re = new RegExp("#UNCOMPLETED_TASK_NUM#", "g");
        value = value.replace(re, Vars.UNCOMPLETED_TASK_NUM_ITEM());
        re = new RegExp("#STOCKSURPLUS#", "g");
        value = value.replace(re, Vars.STOCKSURPLUS_ITEM());
        re = new RegExp("#STOCKSURPLUS2#", "g");
        value = value.replace(re, Vars.STOCKSURPLUS_ITEM2());
        re = new RegExp("#STOCKSURPLUS3#", "g");
        value = value.replace(re, Vars.STOCKSURPLUS_ITEM3());
        re = new RegExp("#TIME#", "g");
        value = value.replace(re, Vars.TIME_ITEM());
        re = new RegExp("#REDEEMCODE#", "g");
        value = value.replace(re, Vars.REDEEMCODE_ITEM());
        re = new RegExp("#REDEEMCODE2#", "g");
        value = value.replace(re, Vars.REDEEMCODE_ITEM2());
        re = new RegExp("#REDEEMCODE3#", "g");
        value = value.replace(re, Vars.REDEEMCODE_ITEM3());

        re = new RegExp("#GOODS_NAME#", "g");
        value = value.replace(re, Vars.GOODS_NAME_ITEM());
        re = new RegExp("#DATETIME#", "g");
        value = value.replace(re, Vars.DATETIME_ITEM());
        re = new RegExp("#GOODS_AMOUNT#", "g");
        value = value.replace(re, Vars.GOODS_AMOUNT_ITEM());
        re = new RegExp("#GROUP_NUM#", "g");
        value = value.replace(re, Vars.GROUP_NUM_ITEM());
        re = new RegExp("#GROUP_LIMITEDTIME#", "g");
        value = value.replace(re, Vars.GROUP_LIMITEDTIME_ITEM());
        re = new RegExp("#GROUP_ENDDATE#", "g");
        value = value.replace(re, Vars.GROUP_ENDDATE_ITEM());
        re = new RegExp("#GROUP_BEGINDATE#", "g");
        value = value.replace(re, Vars.GROUP_BEGINDATE_ITEM());
        re = new RegExp("#FROM_NICKNAME#", "g");
        value = value.replace(re, Vars.FROM_NICKNAME_ITEM());
        re = new RegExp("#GROUP_PART_NUM#", "g");
        value = value.replace(re, Vars.GROUP_PART_NUM_ITEM());
        re = new RegExp("#GROUP_CREATER#", "g");
        value = value.replace(re, Vars.GROUP_CREATER_ITEM());
        re = new RegExp("#RETURN_AMOUNT#", "g");
        value = value.replace(re, Vars.RETURN_AMOUNT_ITEM());
        re = new RegExp("#TALLIESDESC#", "g");
        value = value.replace(re, Vars.TALLIESDESC_ITEM());
        re = new RegExp("#BOOST_NAME#", "g");
        value = value.replace(re, Vars.BOOST_NAME_ITEM());
        re = new RegExp("#GIFTBAG_NAME#", "g");
        value = value.replace(re, Vars.GIFTBAG_NAME_ITEM());
        return value;
    }

    componentWillReceiveProps(nextProps) {
        var msg = this.parseMsg(nextProps.msg);
        this.setState({
            paras: msg.paras,
            url: msg.url,
            title: msg.title,
            miniprogram: msg.miniprogram
        });
    }

    detail() {
        if (this.props.lite) {
            return '';
        } else {
            var hasUrl = this.state.url && this.state.url.length > 0;
            var hasM = this.state.miniprogram && this.state.miniprogram.appid && this.state.miniprogram.pagepath;
            if (hasUrl && !hasM) {
                return '跳转链接：' + this.state.url
            } else if (hasM) {
                return '跳转小程序：[appid=' + this.state.miniprogram.appid + '，跳转路径=' + this.state.miniprogram.pagepath + ']'
            }
        }
    }

    hasDetail() {
        if (this.props.lite) {
            return false;
        } else {
            var hasUrl = this.state.url && this.state.url.length > 0;
            var hasM = this.state.miniprogram && this.state.miniprogram.appid && this.state.miniprogram.pagepath;
            return hasUrl || hasM;
        }
    }

    render() {
        return (
            <div id={"msg" + this.id} className={"msgContainer"} title={this.detail()}>
                {this.state.title ? <p className={'msgTitle'}>{this.state.title}</p> : ''}
                {/*<p className={'msgText msgTime'}>{this.state.time}</p>*/}
                {
                    this.state.paras ? this.state.paras.map(function (data, i) {
                        return (
                            <div key={i} className={'msgText'}>
                                {
                                    data.map(function (item, j) {
                                        return (
                                            item.type == 'var' ? (
                                                    item.value.length == 1 ? <span key={j}
                                                                                   style={item.color}
                                                                                   className={'msgText'}
                                                                                   dangerouslySetInnerHTML={{__html: item.value[0]}}></span> :
                                                        item.value.map(function (v, m) {
                                                            return (
                                                                <p key={m}
                                                                   style={item.color}
                                                                   className={'msgText'}
                                                                   dangerouslySetInnerHTML={{__html: v.length == 0 ? '&nbsp;' : v}}></p>
                                                            )
                                                        })
                                                ) :
                                                <span key={j} dangerouslySetInnerHTML={{__html: item.value[0]}}></span>
                                        )
                                    })
                                }
                            </div>
                        )
                    }) : ''
                }
                {
                    this.hasDetail() ? <div>
                        <div className={'msgSplitline'}></div>
                        <div className={'msgDetail'}>详情<span></span></div>
                    </div> : ''
                }
            </div>
        )
    }
}

export default MsgPreview